export default {
  data() {
    return {
      id: '', //列表ID
      caseMessage: {}, //案例详情
    }
  },
  created() {
    this.id = this.$route.query.id
    this.geCaseMessage()
  },
  methods: {
    //获取情感案例喜爱宁
    geCaseMessage() {
      this.$axios
        .post('/api/index/newsDetail', {
          id: this.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.caseMessage = res.data.data
          }
        })
    },
  },
}
